import { fromJS } from 'immutable'
import {
  USER_IMPORT_REQUEST,
  USER_IMPORT_SUCCESS,
  USER_IMPORT_FAILURE,
  USER_IMPORT_RESET,
} from './../../constants'
import { importModalBody } from '../../components/modal/import-modal-body'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_IMPORT_REQUEST:
      return state
        .set('isFetching', true)
    case USER_IMPORT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('type', 'success')
        .set('status', 'Imported Successfully')
        .set('message', importModalBody(action.payload.importResult))
        .set('importResult', fromJS(action.payload.importResult))
    case USER_IMPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('message', fromJS(action.payload.message))
        .set('importResult', fromJS(action.payload.message))
    case USER_IMPORT_RESET:
      return state
        .delete('importResult')
        .delete('type')
        .delete('message')
        .delete('status')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-import-reducer.js